<app-nav-bar></app-nav-bar>
<div class="tab" role="tabpanel" aria-labelledby="pills-contact-tab">

  <div class="scheduleConference">
   <div class="split left">
   <br>
   <br>
     <!-- <span style="font-size: 30px;font-weight: 600;color: #004526;font-family: 'Rubik', sans-serif;">
      User Profile Photo
       </span> -->
       <br>
       <br>
      <span style="padding: 0 188px;">
        <span><img src="../../assets/images/Layer1.png" alt="User Profile" style=" border: 1px solid #ddd;border-radius: 4px;padding: 5px;width: 65%;"></span><br><br>
        <span style="font-size: 24px;font-weight: 500;color: #004526;margin-left: 354px">{{showUserName}} </span><br><br>
        <!-- <span style="font-size: 17px;font-weight: 500;color: #87b538; margin-left: 360px;">(Software Engineer) </span><br><br> -->
        <button type="submit" class="editProfile" (click)="onUpdate(content2)">
          <i class="fas fa-paper-plane" aria-hidden="true" style="color: #fff;"></i> &nbsp;
          Edit
          </button>
      </span>

          
   </div>
   
   <div class="split right"> 
     <br>
     <br>
     <span style="font-size: 25px;font-weight: 600;color: #004526; margin-left: 10px;font-family: 'Rubik', sans-serif;"> User Profile</span>
     <br>
     <br>
     <!-- <span>
       <span>Name</span>
     </span> -->
     <table class="table">
      <!-- <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">First</th>
          <th scope="col">Last</th>
          <th scope="col">Handle</th>
        </tr>
      </thead> -->
      <tbody *ngFor="let item of getUserProleList">
        <tr>
          <th scope="row" style="font-size: 20px; font-weight: 500;width: 20%;">User Name</th>
          <td style="font-size: 18px; font-weight: 400;">{{item.userName}}</td>
          <!-- <th scope="row">Name</th>
          <td>{{item.name}}</td>
          <th scope="row">Email</th>
          <td colspan="2">{{item.email}}</td>
          <th scope="row">MobileNo</th>
          <td colspan="2">{{item.mobileNo}}</td> -->
       </tr>
        
        <tr>
          <th scope="row" style="font-size: 20px; font-weight: 500;width: 20%;">Name</th>
          <td style="font-size: 18px; font-weight: 400;">{{item.name}}</td>
         
        </tr>
        <tr>
          <th scope="row" style="font-size: 20px; font-weight: 500;width: 20%;">Email</th>
          <td colspan="2" style="font-size: 18px; font-weight: 400;">{{item.email}}</td>
        
        </tr>
        <tr>
          <th scope="row" style="font-size: 20px; font-weight: 500;width: 20%;">MobileNo</th>
          <td colspan="2" style="font-size: 18px; font-weight: 400;">{{item.mobileNo}}</td>
          
        </tr>
        <tr>
          <th scope="row" style="font-size: 20px; font-weight: 500;width: 20%;">Address</th>
          <td colspan="2" style="font-size: 18px; font-weight: 400;">{{item.address}}</td>
          
        </tr>
        
      </tbody>
    </table>
 
   </div>
      
<!--Start Update popup-->
<ng-template #content2 let-c="close" let-d="dismiss">
  <i class="fa fa-close text-danger" style='font-size:15px;color:black;font-size: 21px;margin-left: 445px;margin-top: 24px;cursor: pointer;' (click)="c('Close click')"></i>
  <div class="modal-body" style="
  width: 730px;">
      <div class="col-md-8">
          <div class="card card-user">
              <div class="card-header">
                  <h5 class="card-title" style="font-size: 20px;font-weight: 500;margin-top: 10px;">Update Profile</h5>
              </div>
              <div class="card-body">
                  <form name="updateProfile" id="updateProfile">
                      <div class="row">
                          <div class="col-md-12">
                              <div class="form-group"><label>Name</label>    
                                <input type="text" name="name" class="form-control" [(ngModel)]="update.name">                       
                              </div>
                          </div>
                      </div>
                          
                      <div class="row">

                          <div class="col-md-12">
                              <div class="form-group"><label>Mobile Number</label>
                                <input type="text" name="mobileNo" class="form-control" [(ngModel)]="update.mobileNo">
                              </div>
                          </div>
                      </div>
                      <div class="row">
                          <div class="col-md-12">
                            <div class="form-group"><label>Address</label>
                                <input type="text" name="address" class="form-control" [(ngModel)]="update.address">
                            </div>
                        </div>
                      </div>
                      <!-- <div class="row">
                        <div class="col-md-12">
                          <div class="form-group"><label>Profile Image</label>
                              <input type="file" name="multipleFile" class="form-control" [(ngModel)]="update.multipleFile" >
                          </div>
                      </div>
                    </div> -->
                      <!-- multipleFile -->
                 
                      <div class="row">
                          <div class="update ml-auto mr-auto">
                            <button type="button" class="btn btn-primary btn-round" (click)="onUpdateProfile()"
                            style="background-color: #004526;font-weight: 400;">Update</button></div>
                        
                      </div>
                  </form>
              </div>
          </div>
      </div>
  </div>
  
</ng-template>
<!---End Update-->

<div class="loading-overlay">

  <span class="fa fa-spinner fa-spin" style="font-size:40px"></span>
</div> 

   </div>
 </div>


